import { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Paper,
  Typography
} from "@mui/material";
import { useDispatch } from 'react-redux';
import Close from "@mui/icons-material/Close";
import { useGetSessionQuery, useRespondToSurveyMutation } from '../services/api';
import { toast } from '../features/snackbar/snackbarSlice';

function WatchSurveyDialog({
  guid,
  open,
  setOpen
}: {
  guid?: string;
  open: boolean;
  setOpen: (_: boolean) => void;
}) {
  const dispatch = useDispatch();
  const { data: session } = useGetSessionQuery(guid);
  const [respondToSurvey] = useRespondToSurveyMutation();
  const [days, setDays] = useState({
    su: false,
    m: false,
    tu: false,
    w: false,
    th: false,
    f: false,
    sa: false,
  })
  const [times, setTimes] = useState({
    morning: false,
    afternoon: false,
    evening: false,
    late: false,
  })
  const Checkbawks = ({ checked,
    label,
    onChange,
  }: {
    checked: boolean
    label: string
    onChange: () => void
  }) => (
    <FormControlLabel
      control={<Checkbox
        checked={checked}
        onChange={onChange}
      />}
      label={label}
    />
  )
  const handleDaysChange = (key: keyof typeof days) => () =>
    setDays(_ => ({
      ..._,
      [key]: !_[key]
    }))
  const handleTimesChange = (key: keyof typeof times) => () =>
    setTimes(_ => ({
      ..._,
      [key]: !_[key]
    }))
  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={open}
      PaperProps={{
        style: {
          backgroundColor: '#a0b1af'
        }
      }}
    >
      <DialogTitle>
        <Typography
          fontSize={22}
        >Suggest Days and/or Times</Typography>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Paper
          elevation={0}
          style={{
            alignItems: 'flex-end',
            display: 'flex',
            flexDirection: 'column',
            padding: 26
          }}
        >
          <Box
            component='form'
            display='flex'
            flexDirection='column'
            justifyContent='center'
            onSubmit={(e: any) => {
              e.preventDefault()
              respondToSurvey({
                content: `
                  session: ${session?.title}
                  days: ${Object.keys(days).filter(key => days[key as keyof typeof days]).join(',')}
                  times: ${Object.keys(times).filter(key => times[key as keyof typeof times]).join(',')}
                  `,
                guid
              })
                .unwrap()
                .then(() => {
                  dispatch(
                    toast({
                      message: 'Thank you for you input!',
                      severity: 'success',
                    })
                  );
                  setOpen(false)
                })
            }}
          >
            <Typography>Please indicate which days and/or times would work best for you:</Typography>
            <FormGroup style={{ display: 'flex', flexDirection: 'row' }}>
              <Checkbawks checked={days.su} onChange={handleDaysChange('su')} label="Su" />
              <Checkbawks checked={days.m} onChange={handleDaysChange('m')} label="M" />
              <Checkbawks checked={days.tu} onChange={handleDaysChange('tu')} label="Tu" />
              <Checkbawks checked={days.w} onChange={handleDaysChange('w')} label="W" />
              <Checkbawks checked={days.th} onChange={handleDaysChange('th')} label="Th" />
              <Checkbawks checked={days.f} onChange={handleDaysChange('f')} label="F" />
              <Checkbawks checked={days.sa} onChange={handleDaysChange('sa')} label="Sa" />
            </FormGroup>
            <Divider />
            <FormGroup style={{ display: 'flex', flexDirection: 'row' }}>
              <Checkbawks checked={times.morning} onChange={handleTimesChange('morning')} label="Morning" />
              <Checkbawks checked={times.afternoon} onChange={handleTimesChange('afternoon')} label="Afternoon" />
              <Checkbawks checked={times.evening} onChange={handleTimesChange('evening')} label="Evening" />
              <Checkbawks checked={times.late} onChange={handleTimesChange('late')} label="Late Night" />
            </FormGroup>
            <Button
              type="submit"
              variant='contained'
            >Submit</Button>
          </Box>
        </Paper>
      </DialogContent>
    </Dialog>
  );
}

export default WatchSurveyDialog;